import React from "react";
import { twMerge } from "tailwind-merge";

interface UiTrapezeHandleProps {
  className?: string;
  onClick?: () => void;
  direction?: "left" | "right";
  icon?: React.ReactNode;
}

export default function UiTrapezeHandle({ className, onClick, icon }: UiTrapezeHandleProps) {
  return (
    <div
      className={twMerge(
        "absolute -right-[24px] top-0 z-10 flex h-[60px] w-[25px] cursor-pointer items-center justify-center overflow-hidden text-primary-800 duration-100 hover:text-primary-900 hover:ease-in-out",
        className
      )}
      onClick={onClick}
    >
      <svg className="absolute inset-y-0 right-0" width="26" height="60" viewBox="0 0 26 60" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M1.1118 0.776393L0.75 0.595491V1V59V59.4045L1.1118 59.2236L25.1118 47.2236L25.25 47.1545V47V13V12.8455L25.1118 12.7764L1.1118 0.776393Z"
          className="stroke-neutral-600"
          strokeWidth="0.5"
        />
        <path d="M25 12.9999L0.496094 0.746094V59.2461L25 47.0035V12.9999Z" className="fill-neutral-25" />
      </svg>

      {icon}
    </div>
  );
}
